const getFileBaseUrl = (): string => {
  const origin = window.location.origin
  if (process.env.NODE_ENV === 'development') {
    return '/fileApi/upload/upload/'
  } else {
    return origin.includes('-testserver')
      ? 'https://gec-api-testserver.gecacademy.cn/filesServer/upload/upload/'
      : 'https://gec-api-files.gecacademy.cn/filesServer/upload/upload/'
  }
}

export default getFileBaseUrl() 